// TopInternationalApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'TopInternational'];

// Enhance the base API service by adding entication-related tag types
const TopInternationalApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
      // Fetch TopInternational query (GET request to /me)
      getTopInternational: build.query({
        query: () => ({
          url: `/TopInternationSells`,
        }),
        providesTags: ['TopInternational'],
      }),  
     
       
    }),
    overrideExisting: false,
  });

export default TopInternationalApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetTopInternationalQuery,
 } = TopInternationalApi;


